import { DatePipe } from "@angular/common";
import { Directive, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, Renderer2 } from "@angular/core";

@Directive({
	selector: "[inputpastedate]"
})
export class InputPasteToDateDirective {
	@Output() result = new EventEmitter();

	private regexToValidateDate = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/[12][0-9]{3}$/;

	constructor(
		private _Renderer: Renderer2,
		private _ElementRef: ElementRef,
		private datePipe: DatePipe
	) {}

	@HostListener("paste", ["$event"]) OnPaste($event) {
		const inputedDateByUser: string = $event.clipboardData.getData("text");

		if (this.regexToValidateDate.test(inputedDateByUser.trim())) {
			this.result.emit({ isvalidDate: true, date: this.convertStringToDate(inputedDateByUser) });
		} else {
			this.result.emit({ isvalidDate: false, dateValue: "" });
		}
	}

	private convertStringToDate(dateValue: string): string {
		return dateValue.split("/").reverse().join("-");
	}
}
